import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { AuthorityNumbersSection } from '../components/sections/AuthorityNumbersSection';
import { QuickTestimonialsSection } from '../components/sections/QuickTestimonialsSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { BonusSection } from '../components/sections/BonusSection';
import { ScarcitySection } from '../components/sections/ScarcitySection';
import { PricingSection } from '../components/sections/PricingSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { ClosingSection } from '../components/sections/ClosingSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-390">
      <HeroSection data-id="element-391" />
      <AuthorityNumbersSection data-id="element-392" />
      <QuickTestimonialsSection data-id="element-393" />
      <ProblemSection data-id="element-394" />
      <SolutionSection data-id="element-395" />
      <BenefitsSection data-id="element-396" />
      <BonusSection data-id="element-397" />
      <ScarcitySection data-id="element-398" />
      <PricingSection data-id="element-399" />
      <TestimonialSection data-id="element-400" />
      <GuaranteeSection data-id="element-401" />
      <FAQSection data-id="element-402" />
      <ClosingSection data-id="element-403" />
      <FooterSection data-id="element-404" />
      <SocialProofPopup data-id="element-405" />
    </main>;
}